import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/ui/src/components/landing/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Hero"] */ "/app/apps/ui/src/components/landing/hero.tsx");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.1_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_6d9e40018215248210ec78c841d5abba/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.1.1_@babel+core@7.28.5_@opentelemetry+api@1.9.0_babel-plugin-react-compiler@1.0_6d9e40018215248210ec78c841d5abba/node_modules/next/dist/client/image-component.js");
